module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/tablet-books_0d1be6c.svg";